import { hotkeyPrefix } from '@shared/constants/CommandValues';
import HotkeyModel from '@shared/models/deviceProfiles/HotkeyModel';
import { MacroDisplayModel } from '@shared/models/deviceProfiles/MacroModel';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

export const useHotkeyForCopyMacro = () => {
    const { t } = useTranslation();

    function prepareHotkeysForCopyMacro(macro: MacroDisplayModel, hotkeys: HotkeyModel[]) {
        const newMacro = { ...macro };
        const commands = macro.commands;
        const newHotkeys = [...hotkeys];
        newMacro.commands.forEach((c, i) => {
            if (c.commandType === 'hotkey') {
                const hkLocalId = uuidv4();
                const displayName = c.command.replace(hotkeyPrefix, '');

                newHotkeys.push({
                    localId: hkLocalId,
                    command: c.command + '_copy',
                    displayName: t('common:hotkey.copySuffix', displayName + '_copy', { name: displayName }),
                    macroLocalId: macro.id,
                });

                newMacro.commands[i] = { ...commands[i], command: c.command + '_copy', hotkeyLocalId: hkLocalId };
            }
        });
        newMacro.id = uuidv4();
        newMacro.name = t('common:macros.copySuffix', macro.name + '_copy', { name: macro.name });
        return { newMacro, hotkeys: newHotkeys };
    }

    return prepareHotkeysForCopyMacro;
};
